import { render, staticRenderFns } from "./GsAssist.vue?vue&type=template&id=5dc42298&scoped=true&"
import script from "./GsAssist.vue?vue&type=script&lang=js&"
export * from "./GsAssist.vue?vue&type=script&lang=js&"
import style0 from "./GsAssist.vue?vue&type=style&index=0&id=5dc42298&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dc42298",
  null
  
)

export default component.exports